'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ConsoleLogger = require('./ConsoleLogger');

var _ConsoleLogger2 = _interopRequireDefault(_ConsoleLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logger = _ConsoleLogger2.default;

exports.default = Logger;


/*****************
 ** WEBPACK FOOTER
 ** ./~/fsts/lib/logger/index.js
 ** module id = 56
 ** module chunks = 0
 **/